var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLpLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 40,
    viewBox: "0 0 22 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78866 14.4079C9.78866 16.9186 7.76207 18.9525 5.26054 18.9525C2.76171 18.9525 0.732422 16.9186 0.732422 14.4079V5.32147C0.732422 2.81084 2.76171 0.776886 5.26054 0.776886C7.76207 0.776886 9.78866 2.81084 9.78866 5.32147V14.4079Z",
    fill: "#F77611"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78866 34.799C9.78866 37.3177 7.76207 39.3598 5.26054 39.3598C2.76171 39.3598 0.732422 37.3177 0.732422 34.799V24.5723C0.732422 22.0536 2.76171 20.0115 5.26054 20.0115C7.76207 20.0115 9.78866 22.0536 9.78866 24.5723V34.799Z",
    fill: "#FFCC33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3863 14.4079C21.3863 16.9186 19.357 18.9525 16.8582 18.9525C14.3567 18.9525 12.3301 16.9186 12.3301 14.4079V5.32147C12.3301 2.81084 14.3567 0.776886 16.8582 0.776886C19.357 0.776886 21.3863 2.81084 21.3863 5.32147V14.4079Z",
    fill: "#38DED6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3836 34.799C21.3836 37.3177 19.357 39.3598 16.8582 39.3598C14.3567 39.3598 12.3301 37.3177 12.3301 34.799V24.5723C12.3301 22.0536 14.3567 20.0115 16.8582 20.0115C19.357 20.0115 21.3836 22.0536 21.3836 24.5723V34.799Z",
    fill: "#04C362"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpLogo);
export default __webpack_public_path__ + "static/media/lp-logo.181c0fa9f20cec86863a247cb2fce852.svg";
export { ForwardRef as ReactComponent };